import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiEmergencyStopResponseDto, ApiKillSwitchResponseDto} from '@birco/rainmesh-api';
import {KillSwitchState} from '../../../features/dashboard/state/kill-switch.state';

export interface KillSwitchStateService {

  getKillSwitch(): Observable<ApiKillSwitchResponseDto>;

  triggerKillSwitch(options: { value: boolean }): Observable<ApiKillSwitchResponseDto>;

  getEmergencyStop(): Observable<ApiEmergencyStopResponseDto>;

  triggerEmergencyStop(): Observable<ApiEmergencyStopResponseDto>;
}

export const KILL_SWITCH_STATE_SERVICE_INJECTION_TOKEN = new InjectionToken<KillSwitchState>('KillSwitchStateService');
